import React from 'react';
import styled from 'styled-components';
import {lightColor} from '@ey/styled-theme';

export default function ALRASummary({alraSummaryBodyConfig, setSelectedTab, selectedTab}) {
	const onClick = (value) => {
		setSelectedTab && setSelectedTab(value);
	};

	return (
		<StyledTabHeader className="StyledTabHeader tab-header">
			{alraSummaryBodyConfig.map((tab, index) => (
				<StyledTab
					key={index}
					className={`tab ${index === selectedTab ? 'active' : ''}`}
					onClick={() => onClick(index)}
				>
					{tab.label}
				</StyledTab>
			))}
		</StyledTabHeader>
	);
}

const StyledTabHeader = styled.section`
	display: flex;
	justify-content: flex-end;
	border: var(--px-1) solid var(--neutrals-200);
	background-color: var(--neutrals-100);
	border-radius: var(--px-4);
	padding: var(--px-4);
`;

const StyledTab = styled.section`
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	height: var(--px-32);
	padding: var(--px-8) var(--px-12);
	margin-right: var(--px-4);
	font-size: var(--px-12);
	font-weight: 400;
	line-height: var(--px-16);
	color: var(--neutrals-900);
	border: var(--px-1) solid transparent;
	background-color: transparent;
	min-width: var(--px-60);
	width: auto;
	max-width: var(--px-200);
	&.active,
	&:hover {
		border: var(--px-1) solid var(--neutrals-300);
		border-radius: var(--px-4);
		background-color: var(--neutrals-00white);
		color: var(--neutrals-900);
	}
	&:last-child {
		margin-right: 0;
	}
`;
